import { injectIntl } from "react-intl";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { OperationType } from "src/helpers/Enums";
import apiService from "src/services/api.service";
import SingleSelect from "src/components/SingleSelect";
import MultiSelectWithCheckbox from "src/components/MultiSelectWithCheckbox";

const NewList = (props) => {

    const [list, setList] = useState(props.type === OperationType.UPDATE ? props.list : {
        name: "",
        user_id: "",
        tag_ids: [],
        slot: "",
        segment: "",
        strategy_id: "",
        is_active: true,
    })
    const [openTags, setOpenTags] = useState(false)
    const [openStrategies, setOpenStrategies] = useState(false)
    const [openSegment, setOpenSegment] = useState()
    const [selectedSegment, setSelectedSegment] = useState(props.list?.segment ? {
        id: props.list.segment === "Live" ? 1 : 2,
        name: props.list.segment
    } : null)
    const [selectedTags, setSelectedTags] = useState(props.type === OperationType.UPDATE ? props.list?.tag_ids : [])
    const [selectedStrategy, setSelectedStrategy] = useState(props.type === OperationType.UPDATE ? props.list?.strategy_id : null)
    const [tags, setTags] = useState([])
    const [strategies, setStrategies] = useState([])
    const strategyRef = useRef(null)
    const multiSelectRef = useRef(null)
    const segmentRef = useRef(null)
    const segmentList = [{id: 1, name: "Live"}, {id: 2, name: "Repair"}]

    useEffect(() => {
        apiService.getAllTags().then((response) => {
            setTags(response.data)
        })
        apiService.getAllStrategies().then((response) => {
            setStrategies(response.data)
        })
    }, [])

    useEffect(() => {
        setList({...list, tags: selectedTags?.map(item => item._id)})
    }, [selectedTags])

    const selectSegment = (segment) => {
        setSelectedSegment(segment)
        setList({...list, segment: segment.name})
        setOpenSegment(false)
    }

    const handleClickSingleOutside = useCallback((event) => {
        if (strategyRef.current && !strategyRef.current.contains(event.target)) {
            setOpenStrategies(false)
        }
    }, []);

    const handleClickMultiOutside = useCallback((event) => {
        if (multiSelectRef.current && !multiSelectRef.current.contains(event.target)) {
            setOpenTags(false)
        }
    }, []);

    const handleClickSegmentOutside = useCallback((event) => {
        if (segmentRef.current && !segmentRef.current.contains(event.target)) {
            setOpenSegment(false)
        }
    }, []);

    useEffect(() => {
        document.addEventListener("mousedown", handleClickSegmentOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickSegmentOutside);
        };
    }, [handleClickSegmentOutside]);

    useEffect(() => {
        document.addEventListener("mousedown", handleClickSingleOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickSingleOutside);
        };
    }, [handleClickSingleOutside]);

    useEffect(() => {
        document.addEventListener("mousedown", handleClickMultiOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickMultiOutside);
        };
    }, [handleClickMultiOutside]);

    const toggleTag = (tag) => {
        setSelectedTags(selectedTags?.find((item) => item._id === tag._id) ? selectedTags.filter((t) => t._id !== tag._id) : [...selectedTags, tag])
    }

    const selectStrategy = (strategy) => {
        setSelectedStrategy(strategy)
        setList({...list, strategy_id: strategy._id})
        setOpenStrategies(false)
    }

    const createUpdateList = () => {
        switch (props.type) {
            case OperationType.CREATE:
                apiService.createList({...list, type: "SMS"}).then(() => {
                    props.closeModal()
                })
                break
            case OperationType.UPDATE:
                apiService.updateList({...list, type: "SMS"}).then(() => {
                    props.closeModal()
                })
                break
        }
    }

    const handleInput = (param, value) => {
        setList({...list, [param]: value})
    }

    const handleKeyDown = (e) => {
        if (e.key === "-") {
            e.preventDefault();
        }
    }

    const isEnableButton = () => {
        let isEnable = false
        if (list?.name && list?.slot && list?.segment && list?.strategy_id && list?.tags?.length > 0) {
            isEnable = true
        }
        return isEnable
    }

    const closeModals = () => {
        setOpenTags(false)
    };

    const handleChooseList = (item) => {
        setSelectedTags(selectedTags?.find((tag) => tag._id === item._id) ? selectedTags.filter((list) => list._id !== item._id) : [...selectedTags, item])
    }

    return (
        <div className="NewStrategyModalOverlay">
            <div className="NewStrategyModal">
                <div className={ "w-full flex justify-between" }>
                    <div className={ props.type === OperationType.CREATE ? "NewStrategy" : "NewCreative" }>
                        <img alt={ "Logo" }
                             src={ props.type === OperationType.CREATE ? "/media/icons/purplePlusIcon.svg" : "/media/icons/editIcon.svg" }
                             className={ "w-[18px] h-[18px]" }/>
                        { props.type === OperationType.CREATE ? "New" : "Edit" } List
                    </div>
                    <button className={ "CloseIconButton" } onClick={ props.closeModal }>
                        <img alt={ "Logo" } src={ "/media/icons/closeIcon.svg" } className={ "w-5 h-5" }/>
                    </button>
                </div>
                <div className={ "ListNameInputSection" }>
                    <div className={ "NewStrategyInputTitle" }>List Name</div>
                    <input className={ "NewStrategyInput" } type="text" placeholder="Enter"
                           onChange={ (e) => handleInput("name", e.target.value) } value={ list?.name }/>
                    <div className={ "flex gap-[6px] items-center w-full" }>
                        <img alt={ "Logo" } src={ "/media/icons/fromName.svg" }
                             className={ "w-[18px] h-[18px]" }/>
                        <input className={ "ListFromNameInput" } type="text" placeholder="Enter"
                               onChange={ (e) => handleInput("from_name", e.target.value) } value={ list?.from_name }/>
                    </div>
                </div>
                <div className={ "NewStrategyInputSection" }>
                    <div className={ "NewStrategyInputTitle" }>Slot</div>
                    <input className={ "NewStrategyInput" } type="number" min={ 0 } placeholder="Enter"
                           onChange={ (e) => handleInput("slot", e.target.value) } onKeyDown={ handleKeyDown }
                           value={ list?.slot }/>
                </div>
                <div className={ "NewStrategyInputSection" } ref={ segmentRef }>
                    <div className={ "NewStrategyInputTitle" }>Segment</div>
                    { openSegment ?
                        <SingleSelect setOpenSelect={ setOpenSegment } selectedItem={ selectedSegment }
                                      selectItem={ selectSegment }
                                      list={ segmentList }></SingleSelect> :
                        <button className={ "TagSelect" }
                                onClick={ () => setOpenSegment(true) }>{ selectedSegment ?
                            <div className="flex gap-1 items-center text-black">
                                <div
                                    className={ selectedSegment?.name === "Live" ? "ListSegmentLive" : "ListSegmentRepair" }></div>
                                { selectedSegment?.name }
                            </div>
                            : "Select" }
                            <img alt={ "Logo" } src={ "/media/icons/chevronDown.svg" }
                                 className={ "w-[18px] h-[18px]" }/>
                        </button>
                    }
                </div>
                <div ref={ strategyRef } className={ "NewStrategyInputSection" }>
                    <div className={ "NewStrategyInputTitle" }>Strategy</div>
                    { openStrategies ?
                        <SingleSelect setOpenSelect={ setOpenStrategies } selectedItem={ selectedStrategy }
                                      selectItem={ selectStrategy } list={ strategies }></SingleSelect> :
                        <button className={ "TagSelect" }
                                onClick={ () => setOpenStrategies(true) }>{ selectedStrategy ?
                            <div className="text-black">{ selectedStrategy.name }</div>
                            : "Select" }
                            <img alt={ "Logo" } src={ "/media/icons/chevronDown.svg" }
                                 className={ "w-[18px] h-[18px]" }/>
                        </button>
                    }
                </div>
                <div ref={ multiSelectRef } className={ "NewStrategyInputSection" }>
                    <div className={ "NewStrategyInputTitle" }>Tag</div>
                    { openTags ? <MultiSelectWithCheckbox list={ tags } selectedItem={ selectedTags }
                                                          handleChooseList={ handleChooseList } close={ closeModals }
                                                          img={ "/media/icons/offer.svg" } title={ "Offers" }
                                                          titleImg={ "/media/icons/offerPurple.svg" }></MultiSelectWithCheckbox> :
                        <button className={ "TagSelect" }
                                onClick={ () => setOpenTags(true) }>{ selectedTags?.length > 0 ?
                            <div className={ "SelectedTags" }>
                                { selectedTags.map((tag) => (
                                    <div key={ tag._id }
                                         className="SelectedTag">
                                        { tag.name }
                                        <button type="button" className="ml-2 text-indigo-700 hover:text-indigo-900"
                                                onClick={ () => toggleTag(tag) }>
                                            <img alt={ "Logo" } src={ "/media/icons/closeIcon.svg" }
                                                 className={ "w-[18px] h-[18px]" }/>
                                        </button>
                                    </div>
                                )) }
                            </div> : "Select" }
                            <img alt={ "Logo" } src={ "/media/icons/chevronDown.svg" }
                                 className={ "w-[18px] h-[18px]" }/>
                        </button>
                    }
                </div>
                <div className={ "NewListTypeButtons" }>
                    <button onClick={ () => handleInput("is_active", true) }
                            className={ list?.is_active ? "NewListChosenButton" : "NewListButton" }>Active
                        { list?.is_active && <span className={ "ChosenMarkerListType" }></span> }
                    </button>
                    <img alt={ "Logo" } src={ "/media/icons/separate.png" } className={ "h-[22px] w-[1px]" }/>
                    <button onClick={ () => handleInput("is_active", false) }
                            className={ !list?.is_active ? "NewListChosenButton" : "NewListButton" }>Inactive
                        { !list?.is_active && <span className={ "ChosenMarkerListType" }></span> }
                    </button>
                </div>
                <div className={ "NewStrategyInputSection" }>
                    <div className={ "NewStrategyInputTitle" }>Note
                        <span className={ "Optional" }>(Optional)</span>
                    </div>
                    <input className={ "NewStrategyInput" } type="text" placeholder="Enter"
                           onChange={ (e) => handleInput("note", e.target.value) } onKeyDown={ handleKeyDown }
                           value={ list?.note }/>
                </div>
                <div className="modal-actions">
                    <button type="button" onClick={ props.closeModal } className="CloseButton">
                        Close
                    </button>
                    <button className="CreateButton" disabled={ !isEnableButton() }
                            onClick={ createUpdateList }>
                        { props.type === OperationType.CREATE ? "Create" : "Save" }
                    </button>
                </div>
            </div>
        </div>
    );
}

export default injectIntl(NewList);
